export const DOCUMENT_TYPE_FRONTPAGE = 'frontpage';
